import { useQuery } from "@tanstack/react-query";

import { crefazCltService } from "../services/crefazCltService";
import { CrefazCltContextType } from "../services/crefazCltService/context";

const STALE_TIME = 1000 * 60 * 60;

export const useCrefazCltContext = (
  type: CrefazCltContextType,
  enabled = true,
) => {
  const { data, isFetching, isLoading, isError } = useQuery({
    queryKey: ["crefaz-clt-context", type],
    queryFn: () => crefazCltService.getContext(type),
    select: (response) => response.data,
    staleTime: STALE_TIME,
    enabled,
  });

  return { items: data ?? [], isFetching, isLoading, isError };
};
